import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import { isPrerender } from '../utils/isPrerender';
import SectionTitle from './SectionTitle';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const FB_PAGE = 'https://www.facebook.com/TTBriancon';

const SocialWall = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (isPrerender()) return;
    let cancelled = false;

    axios
      .get('/api/facebook-posts.php', { timeout: 10000 })
      .then((res) => {
        if (cancelled) return;
        setPosts(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  // slidesToShow adapté au nombre de posts pour éviter les clones / cases vides.
  const show = (n) => Math.max(1, Math.min(n, posts.length));
  const slickSettings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: show(3),
    infinite: posts.length > 3,
    responsive: [
      { breakpoint: 1100, settings: { slidesToShow: show(2), infinite: posts.length > 2 } },
      { breakpoint: 700, settings: { slidesToShow: 1, infinite: posts.length > 1 } },
    ],
  };

  return (
    <div className="section section--seam section--rose social-wall-fb">
      <SectionTitle overline="Actualités">Suivez-nous</SectionTitle>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : posts.length > 0 ? (
        <Slider {...slickSettings} className="posts-slider">
          {posts.map((post) => {
            const hasImage = Boolean(post.full_picture);
            return (
              <div key={post.id || post.permalink_url} className="post-slide">
                <a
                  href={post.permalink_url || FB_PAGE}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`post-card${hasImage ? '' : ' post-card--text'}`}
                >
                  {hasImage && (
                    <div className="post-image-container">
                      <img
                        src={post.full_picture}
                        alt=""
                        className="post-image"
                        decoding="async"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className="post-body">
                    {post.message && <p className="post-message">{post.message}</p>}
                    {post.created_time && (
                      <span className="post-date">Publié le {formatDate(post.created_time)}</span>
                    )}
                  </div>
                </a>
              </div>
            );
          })}
        </Slider>
      ) : (
        <p className="text-center">
          {error
            ? 'Les publications ne sont pas disponibles pour le moment.'
            : 'Aucune publication récente.'}
        </p>
      )}

      <p className="social-wall-cta text-center">
        <a className="btn btn-secondary" href={FB_PAGE} target="_blank" rel="noopener noreferrer">
          Voir la page Facebook
        </a>
      </p>
    </div>
  );
};

export default SocialWall;
